import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardWithNotesColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#CFDEFF"
        d="M7.65 3.278h-.5a3 3 0 0 0-3 3V17.75a3 3 0 0 0 3 3h9.5a3 3 0 0 0 3-3V6.278a3 3 0 0 0-3-3z"
      />
      <path
        stroke="#082A74"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7.65 3.278h-.5a3 3 0 0 0-3 3V17.75a3 3 0 0 0 3 3h9.5a3 3 0 0 0 3-3V6.278a3 3 0 0 0-3-3h-.5m-8.5 0h4.25m-4.25 0v.972m0-.972V2.25m4.25 1.028h4.25m-4.25 0v.972m0-.972V2.25m4.25 1.028v.972m0-.972V2.25m-7.5 7.5h6.5m-6.5 4h4.5"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClipboardWithNotesColored);
export default ForwardRef;
